export class CalibrationOptions {
	public StartCalibrationPossible: boolean;
	public StopCalibrationPossible: boolean;

	constructor(startCalibrationPossible: boolean, stopCalibrationPossible: boolean) {
		this.StartCalibrationPossible = startCalibrationPossible;
		this.StopCalibrationPossible = stopCalibrationPossible;
	}
}
